import { Stack, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";
import { PAGE_THREE_STYLES } from "../constants";
import { PageThreeFormData } from "../models";

const InfoField = ({ 
  label, 
  name, 
  isDate, 
  multiline, 
  control, 
  t 
}: { 
  label: string; 
  name: keyof PageThreeFormData; 
  isDate?: boolean; 
  multiline?: boolean;
  control: any;
  t: any;
}) => (
  <Grid md={4} xs={12} sx={PAGE_THREE_STYLES.gridItem}>
    <Grid sx={PAGE_THREE_STYLES.gridPadding}>
      <ByzMuiTypography sx={PAGE_THREE_STYLES.label}>
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={PAGE_THREE_STYLES.gridPadding}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          isDate ? (
            <ByzMuiDatePicker
              {...field}
              onChange={(date: any) => field.onChange(date)}
              sx={PAGE_THREE_STYLES.datePicker}
            />
          ) : (
            <ByzMuiTextField
              {...field}
              multiline={multiline}
              rows={multiline ? 2 : 1}
              sx={PAGE_THREE_STYLES.textField}
            />
          )
        )}
      />
    </Grid>
  </Grid>
);

const VitalSignsAndHistory: React.FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageThreeFormData>();

  return (
    <>
      <Grid sx={PAGE_THREE_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingTop="5px">
          {t("adult-patient-assessment.vital-signs-and-history")}
        </ByzMuiTypography>
      </Grid>
      
      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap">
        <InfoField label="adult-patient-assessment.height" name="height" control={control} t={t} />
        <InfoField label="adult-patient-assessment.weight" name="weight" control={control} t={t} />
        <InfoField label="adult-patient-assessment.ideal-weight" name="idealWeight" control={control} t={t} />
        <InfoField label="adult-patient-assessment.bmi" name="bmi" control={control} t={t} />
        <InfoField label="adult-patient-assessment.waist-circumference" name="waistCircumference" control={control} t={t} />
        <InfoField label="adult-patient-assessment.head-circumference" name="headCircumference" control={control} t={t} />
      </Stack>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Stack direction="row" sx={{ paddingTop: "10px" }} flexWrap="wrap">
        <InfoField label="adult-patient-assessment.last-menstrual-period" name="lastMenstrualPeriod" isDate control={control} t={t} />
        <InfoField label="adult-patient-assessment.medical-history-summary" name="medicalHistorySummary" multiline control={control} t={t} />
      </Stack>
    </>
  );
};

export default VitalSignsAndHistory;
